/**
 * Shared display-formatting utilities used across the host app and widget packages.
 * All functions are pure and locale-aware where appropriate.
 */

/** Compact count: 1 234 → "1.2k", 1 234 567 → "1.2M". */
export function formatCount(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}k`;
  return value.toLocaleString();
}

/**
 * Percentage from a 0–1 rate: 0.856 → "86%".
 * @param fraction – value between 0 and 1
 * @param decimals – decimal places (default 0)
 */
export function formatPct(fraction: number, decimals = 0): string {
  return `${(fraction * 100).toFixed(decimals)}%`;
}

/** Storage size in GB → human-readable: 0.5 → "500 MB", 1500 → "1.5 TB". */
export function formatBytes(gb: number): string {
  if (gb >= 1000) return `${(gb / 1000).toFixed(1)} TB`;
  if (gb >= 1) return `${gb.toFixed(1)} GB`;
  return `${(gb * 1000).toFixed(0)} MB`;
}
